// External
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';

// Internal
import { UsefulService } from '../../../../common/services/global/useful/useful.service';
import { ModalContainerOptions, ModalProperties, ModalSize } from '../../../../common/services/global/modal/Modal.model';
import { InstallScenarios, ProductsToInstall, ValuesService } from '../../../../common/values/values.service';
import { ModalName, ModalRoutelessService } from '../../../../common/components/ui/ui-modal-routeless/modal.routeless.service';
import { ProductsConfigService } from '../../../config/products.config.service';

@Injectable({
    providedIn: 'root'
})

export class OpenModalsService {

    openEventBroadcaster: ReplaySubject<any> = new ReplaySubject(1);
    closeEventBroadcaster: Subject<string> = new Subject();

    modalsBufferStorage = {};
    availableModalInfos = {};
    modalProperties: ModalProperties = {
        activated: false,
        modalActivated: null,
        modalOpening: false,
        activeStepInActiveModal: null,
        isAnimating: false
    };

    constructor(
        private readonly modalRoutelessService: ModalRoutelessService,
        private readonly valuesService: ValuesService,
        private readonly usefulService: UsefulService,
        private readonly router: Router,
        private readonly productsConfigService: ProductsConfigService
    ) {}

    /**
     * Opens the install modal in 'other devices' step
     * @param {boolean} override If set to true it will override the data about the modal that is closing
     * @param {ProductsToInstall} product The product to be installed
     * @param {string} profileHash The hash profile of the child
     */
    public openInstallModalOtherDevices(override: boolean, product: ProductsToInstall, profileHash?: string): void {
        if (product === ProductsToInstall.PARENTAL) {
            localStorage.setItem(this.valuesService.installParentalFlag, 'true');
            this.router.navigate([this.valuesService.centralPaths.parental.path]);
            return;
        }

        const isMobileDevice = this.usefulService.isTabletOrMobileDevice();

        const modalContent: any = {
            scenario: product,
            currentStep: InstallScenarios.OTHER_DEVICES
        };

        const modalContainer = {
            size: ModalSize.LG,
            exceptionClass: isMobileDevice ? 'light-close' : ''
        };

        if (profileHash) {
            modalContent.profileHash = profileHash;
        }
        this.modalRoutelessService.open(ModalName.installProtectionModal, modalContainer, modalContent, override);
    }


    /**
     * Opens install flow for parental at the create profile step for NCC
     * @public
     * @memberof OpenModalsService
     * @param {boolean} override If set to true it will override the data about the modal that is closing
     */
     public openCreateProfileParentalNCC(override: boolean): void {
        const isMobileDevice = this.usefulService.isTabletOrMobileDevice();

        const modalContent = {
            scenario: ProductsToInstall.PARENTALNCC,
            currentStep: InstallScenarios.CREATE_PROFILE
        };

        const modalContainer = {
            size: ModalSize.LG,
            exceptionClass: isMobileDevice ? 'light-close' : ''
        };

        this.modalRoutelessService.open(ModalName.installProtectionModal, modalContainer, modalContent, override, true);
    }

    /**
     * Opens install modal for a specific app
     * @public
     * @memberof OpenModalsService
     * @param {string} app_id The id of the app to be installed
     * @param {string} serviceId service id - not human readable
     * @param {boolean} override If set to true it will override the data about the modal that is closing
     */
    public openInstallModalForApp(app_id: string, serviceId: string, override = false): void {

        const productToInstall = this.productsConfigService.getAppProductToInstall(app_id);

        const contentOptions = {
            scenario: productToInstall ?? ProductsToInstall.PROTECTION,
            app_id: app_id,
            service_id: serviceId // legacy
        };
        const containerOptions: ModalContainerOptions = {
            size: ModalSize.LG
        };
        this.modalRoutelessService.open(ModalName.installModal, containerOptions, contentOptions, override);
    }
}
